"use client";

import { Table } from "@tanstack/react-table";
import { useUserFilterActions } from "../../ducks/filter/hooks/actions";
import { useCallback, useState } from "react";
import { debounce } from "lodash";
import { Input } from "components/ui/input";
import { Loader2 } from "lucide-react";
import { SettingsModal } from "../modal/settings-modal";
import { DataTableViewOptions } from "./data-table-view-options";

interface DataTableToolbarProps<TData> {
  table: Table<TData>;
}

export function DataTableToolbar<TData>({
  table,
}: DataTableToolbarProps<TData>) {
  const { updateFilter } = useUserFilterActions();
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsLoading(true);
      updateFilter({ key: "search", value: event.target.value });
      setTimeout(() => setIsLoading(false), 500);
    },
    [updateFilter]
  );

  const debouncedHandleInputChange = useCallback(
    debounce(handleInputChange, 500),
    [handleInputChange]
  );

  return (
    <div className="w-full flex items-center justify-between">
      <div className="relative">
        <Input
          placeholder="Filtrar Query..."
          className="px-3 ml-auto h-8"
          onChange={debouncedHandleInputChange}
        />
        {isLoading && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <Loader2 className="h-4 w-4 animate-spin text-gray-400" />
          </div>
        )}
      </div>
      <div className="flex gap-2">
        <DataTableViewOptions table={table} />
        <SettingsModal />
      </div>
    </div>
  );
}
